<template>
  <div class="home jb-box">
    <div class="banner-container">
      <img
        src="../assets/img/mainbanner.jpg"
        alt="Main Banner"
        class="main-banner"
      />
    </div>

    <div class="search-container">
      <b-input-group size="lg" class="mb-3">
        <b-form-input
          v-model="searchQuery"
          placeholder="검색어 입력"
          @keyup.enter="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button @click="search">검색</b-button>
        </b-input-group-append>
      </b-input-group>
    </div>

    <b-container>
      <b-row>
        <b-col cols="12">
          <b-list-group>
            <b-list-group-item
              v-for="item in results"
              :key="item.id"
              @click="openDetail(item)"
              class="cursor-pointer"
            >
              <b-row>
                <b-col cols="8">
                  <h5 class="list-item-title">{{ item.title }}</h5>
                  <p>{{ truncate(item.contents, 100) }}</p>
                </b-col>
                <b-col cols="4" class="text-right">
                  <small
                    >{{ item.updateUserName }} | {{ formatDate(item.date) }} |
                    조회 {{ item.count }}</small
                  >
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>

    <Spinner v-if="loading" />

    <!-- Modal -->
    <modal
      name="detail-modal"
      :width="modalWidth"
      :height="modalHeight"
      :resizable="true"
      :adaptive="true"
      draggable=".modal-header-draggable"
      :clickToClose="true"
      v-if="selectedItem"
    >
      <div class="modal-header-draggable">
        <h3>{{ selectedItem.title }}</h3>
        <button class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <div v-html="selectedItem.contentsHTML"></div>
      </div>
    </modal>
  </div>
</template>

<script>
import Spinner from "../components/Spinner";
import { mapGetters } from "vuex";
import { init, conversion, setSnackBarInfo } from "../js/common_function";

export default {
  name: "Home",
  components: {
    Spinner,
  },
  data() {
    return {
      searchQuery: "",
      results: [],
      loading: false,
      selectedItem: null,
      modalWidth: window.innerWidth * 0.8,
      modalHeight: window.innerHeight * 0.8,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  watch: {
    isMobile() {
      this.updateModalSize(); // 화면 크기 변경 시 Modal 크기 업데이트
    },
  },
  methods: {
    search() {
      this.loading = true;
      this.$axios({
        url: this.$config.baseBulletinAppURL + "/allBulletinList",
        method: "post",
        data: {
          makeUserName: localStorage.getItem("username"),
          searchSet: this.searchQuery,
          sort: "all",
          lastLogin: localStorage.getItem("lastLogin"),
        },
        headers: { "token-key": localStorage.getItem("token-key") },
      })
        .then((response) => {
          if (response.data.length === 0) {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("검색 내역 없음.")
            );
          }
          this.results = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$store.commit(
            "SET_SNACKBAR",
            setSnackBarInfo("검색 중 오류가 발생했습니다.")
          );
        });
    },
    truncate(text, length) {
      return text.length > length ? `${text.substring(0, length)}...` : text;
    },
    formatDate(date) {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date).toLocaleDateString("ko-KR", options);
    },
    updateModalSize() {
      const width = window.innerWidth;
      const height = window.innerHeight;

      if (this.isMobile) {
        // 모바일 환경에서는 화면 비율에 맞게 설정
        this.modalWidth = `${Math.round(width * 0.9)}px`;
        this.modalHeight = `${Math.round(height * 0.8)}px`;
      } else {
        // 데스크톱 환경에서는 기존 비율 유지
        this.modalWidth = `${Math.min(800, width * 0.8)}px`;
        this.modalHeight = `${Math.min(600, height * 0.8)}px`;
      }
    },
    closeModal() {
      this.$modal.hide("detail-modal");
      this.selectedItem = null; // 초기화
    },
    async openDetail(item) {
      try {
        const response = await this.$axios.post(
          `${this.$config.baseBulletinAppURL}/checkBulletinList`,
          { id: item.id, sort: item.sort },
          { headers: { "token-key": localStorage.getItem("token-key") } }
        );
        this.selectedItem = { ...item, ...response.data[0] };
        this.updateModalSize(); // Modal 크기 업데이트
        this.$nextTick(() => {
          this.$modal.show("detail-modal");
        });
      } catch (error) {
        console.error("Error fetching detail:", error);
        this.$store.commit(
          "SET_SNACKBAR",
          setSnackBarInfo("상세 정보를 불러오는 중 오류가 발생했습니다.")
        );
      }
    },
  },
  mounted() {
    this.$parent.$parent.$children.map(function (value, key) {
      if (value.$options._componentTag === "AppBar") {
        value.navTopBar = false;
      }
    });
    window.addEventListener("resize", this.updateModalSize);
    init(this.$route.fullPath).catch(console.error);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateModalSize);
  },
};
</script>

<style scoped>
.home {
  position: relative;
}
.jb-box {
  text-align: center;
  margin-top: 20vh;
}
.banner-container {
  max-width: 40%;
  margin: auto;
  margin-bottom: 20px;
}
.main-banner {
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.search-container {
  max-width: 500px;
  margin: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.b-list-group-item {
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 15px;
  transition: background-color 0.3s ease;
}
.b-list-group-item:hover {
  background-color: #f8f8f8;
}
.list-item-title {
  font-size: 1.2rem;
  margin-bottom: 5px;
  color: black;
}
p {
  font-size: 1rem;
  margin-bottom: 10px;
  color: #666;
}
small {
  font-size: 0.8rem;
  color: #999;
}

/* 모달 스타일 */
.modal-header-draggable {
  cursor: move;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.modal-header-draggable h3 {
  margin: 0;
  font-size: 1.4rem;
}

.modal-header-draggable .close {
  font-size: 2rem;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.modal-header-draggable .close:hover {
  opacity: 0.8;
}

.modal-body {
  overflow-y: auto;
  height: calc(100% - 60px);
  padding: 20px;
}

/* 크기 조절 핸들 스타일 */
.vmodal .resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 10px;
  height: 10px;
  cursor: se-resize;
}

/* 다른 방향의 크기 조절 핸들 숨기기 */
.vmodal .resize-handle.top-right,
.vmodal .resize-handle.bottom-left,
.vmodal .resize-handle.top-left {
  display: none;
}

/* 스크롤바 스타일 */
.modal-body::-webkit-scrollbar {
  width: 8px;
  display: block;
}

.modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* mobile layout*/
@media (max-width: 768px) {
  .banner-container {
    max-width: 70%;
  }
  .search-container {
    max-width: 90%;
  }
  .modal-header-draggable h3 {
    font-size: 1.2rem;
  }
  .modal-body {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .banner-container {
    max-width: 90%;
  }
  .search-container {
    max-width: 100%;
  }
  .modal-header-draggable h3 {
    font-size: 1rem;
  }
}
</style>
